import React, { useEffect, useState } from "react";
import { Box, Typography, Tabs, Tab, CircularProgress } from "@mui/material";

import { AssignmentOutlined, QuizOutlined } from "@mui/icons-material";
import {
  createAssessmentAPIEndpoint,
  EndPoints,
} from "../../../services/AssessmentServices";
import ResultCard from "./ResultCard";

function ResultsPage() {
  const [type, setType] = useState("Exam");
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadReports = async () => {
    setLoading(true);

    try {
      createAssessmentAPIEndpoint(EndPoints.getMyResults)
        .fetchWithParams({ type: type === "Exam" ? 0 : 1 })
        .then((res) => {
          console.log("Reports fetched successfully:", res.data);
          setReports(res.data);
        })
        .catch((error) => {
          console.error("Error fetching reports:", error);
        });
    } catch (error) {
      console.error("Failed to load results:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReports();
  }, [type]);

  return (
    <section className="section" translate="no">
      <Box className="results-header">
        <Typography variant="h4">My Results</Typography>

        <Typography variant="body1">
          Track your exams and homework results
        </Typography>
      </Box>

      <Box className="results-tabs">
        <Tabs value={type} onChange={(e, value) => setType(value)}>
          <Tab
            value="Exam"
            label="Exams"
            icon={<QuizOutlined />}
            iconPosition="start"
          />

          <Tab
            value="Homework"
            label="Homework"
            icon={<AssignmentOutlined />}
            iconPosition="start"
          />
        </Tabs>
      </Box>

      {loading ? (
        <Box className="results-loading">
          <CircularProgress />
        </Box>
      ) : reports.length === 0 ? (
        <Box className="empty-results">
          <Typography variant="h6">No results yet</Typography>

          <Typography variant="body2">
            Your results will appear here after completing an exam or homework.
          </Typography>
        </Box>
      ) : (
        <Box className="results-grid">
          {reports.map((report) => (
            <ResultCard key={report.assessmentId} report={report} />
          ))}
        </Box>
      )}
    </section>
  );
}

export default ResultsPage;
